// @ts-nocheck
import { Column } from 'react-table'
import { TitleCell } from './TitleCell'
import { UserCustomHeader } from './CustomHeader'
import moment from 'moment';
import { ActionCell } from './ActionCell';
import { TextCell } from './TextCell';


const invoiceDetailListColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Invoice Number' className='min-w-50px' />
    ),
    id: 'invoice_number',
    Cell: ({ ...props }) => <TextCell userObj={props.data[props.row.index]?.invoice_number} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Invoice date' className='min-w-50px' />
    ),

    id: 'invoice_date',
    Cell: ({ ...props }) => {
      const rawDate = props.data[props.row.index]?.invoice_date;
      const formattedDate = rawDate ? moment(rawDate).format("YYYY/MM/DD") : "-";
      return <TitleCell userObj={formattedDate} />;
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title="Numero d'ordine" className='min-w-50px' />
    ),
    id: 'order_number',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.order_number} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Codice articolo' className='min-w-50px' />
    ),
    id: 'article_code',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.article_code} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Quantità' className='min-w-50px' />
    ),
    id: 'quantity',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.quantity} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Prezzo' className='min-w-50px' />
    ),
    id: 'price',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.price} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Valuta' className='min-w-50px' />
    ),
    id: 'currency',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.currency} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Descrizione' className='min-w-50px' />
    ),
    id: 'description',
    Cell: ({ ...props }) => <TitleCell userObj={props.data[props.row.index]?.description} />,
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Data di consegna prevista' className='min-w-50px' />
    ),
    id: 'expected_delivery_date',
    Cell: ({ ...props }) => {
      const rawDate = props.data[props.row.index]?.expected_delivery_date;
      const formattedDate = rawDate ? moment(rawDate).format("YYYY/MM/DD") : "-";
      return <TitleCell userObj={formattedDate} />;
    },
  },
  {
  Header: (props) => (
    <UserCustomHeader tableProps={props} title="Is Exported" className="min-w-50px" />
  ),
  id: "isExported",
  Cell: ({ row, data }) => {
    const value = data[row.index]?.isExported;
    const badgeStyle = {
      padding: "4px 10px",
      borderRadius: "12px",
      color: "white",    
      backgroundColor: value ? "#20c997" : "#fd7e14", 
      fontWeight: 500,
      textAlign: "center",
      display: "inline-block",
      minWidth: "50px",
    };
    return <span style={badgeStyle}>{value ? "TRUE" : "FALSE"}</span>;
  },
},


  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Azione' className='min-w-75px' />
    ),
    id: 'action',
    Cell: ({ ...props }) => {
      const isExported = props.data[props.row.index]?.isExported;
      if (isExported) return null;
      return <ActionCell user={props.data[props.row.index]} isModalContext={true} />;
    },
  }

]

export { invoiceDetailListColumns }

